export enum AppLanguageCode {
    nl = "nl",
    fr = "fr",
    en = "en",
    de = "de",
    it = "it",
    es = "es",
};

export type ByAppLangCode<T> = {
    readonly [AppLanguageCode.en]: T;
    readonly [AppLanguageCode.fr]: T;
    readonly [AppLanguageCode.de]: T;
    readonly [AppLanguageCode.es]: T;
    readonly [AppLanguageCode.it]: T;
    readonly [AppLanguageCode.nl]: T;
};
